import { AbsenceIllustration, SchoolEventIllustration, SubstitutionIllustration } from '@bp/ui-components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { IconMenu } from '../../../components/IconMenu/IconMenu';
import { IconMenuItem } from '../../../components/IconMenuItem/IconMenuItem';
import { Page } from '../../../components/Page/Page';
import { usePermissionChecker } from '../../../hooks/usePermissionChecker';

export const SubstitutionsPlanPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const permissions = usePermissionChecker();

  return (
    <Page
      isForbidden={!permissions?.canManageSubstitution()}
      title={`${t(`substitutions.title`, { count: 2 })} ${t('substitutions.plan').toLowerCase()}`}
    >
      <IconMenu headline={t('common.whatToPlan')}>
        <IconMenuItem
          label={t('schoolEvents.title', { count: 2 })}
          icon={<SchoolEventIllustration />}
          bubbleType={17}
          onClick={() => navigate(t('routes.schoolEvents.slug'))}
        />
        <IconMenuItem
          label={t('absences.title', { count: 2 })}
          icon={<AbsenceIllustration />}
          bubbleType={7}
          onClick={() => navigate(t('routes.absences.slug'))}
        />
        <IconMenuItem
          label={t(`substitutions.title`, { count: 2 })}
          icon={<SubstitutionIllustration />}
          bubbleType={9}
          onClick={() => navigate(t('routes.substitutions.slug'))}
        />
      </IconMenu>
    </Page>
  );
};
